
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import { Form } from "element-ui/types";
import { cloneDeep } from "lodash";
import uploadImg from "@/components/uploadImg.vue";
import config from "@/config/default";
import { appPageSave } from "@/api/appCompose";

interface FormData {
    id: number | string;
    pageMainTitle: string;
    pageSubTitle: string;
    pageChildTitle: string;
    pageBgImg: string;
    pageAnimationImg: string;
    pageBottomImg: string;
}

const defaultFormData: FormData = {
    id: "",
    pageMainTitle: "",
    pageSubTitle: "",
    pageChildTitle: "",
    pageBgImg: "",
    pageAnimationImg: "",
    pageBottomImg: "",
};

@Component({
    components: {
        uploadImg
    }
})
export default class PageCustomDialog extends Vue {
    @Prop({ default: false }) visible!: boolean;
    @Prop({ default: () => ({}) }) rowData!: any;

    @Ref("validateForm") validateForm!: Form;

    loading = false;
    formData: FormData = cloneDeep(defaultFormData);

    // 图片列表（用于uploadImg组件）
    pageBgImgList: any[] = [];
    pageAnimationImgList: any[] = [];
    pageBottomImgList: any[] = [];

    get uploadUrl() {
        return config.uploadImg + "icon";
    }

    rules = {
        pageMainTitle: [
            { max: 30, message: "最多输入30个字", trigger: "blur" }
        ],
        pageSubTitle: [
            { max: 100, message: "最多输入100个字", trigger: "blur" }
        ],
        pageChildTitle: [
            { max: 50, message: "最多输入50个字", trigger: "blur" }
        ],
    };

    @Watch("visible")
    onVisibleChange(val: boolean) {
        if (val && this.rowData) {
            // 优先从 appPageCustom 中读取数据
            const customData = this.rowData.appPageCustom || {};
            // 打开弹窗时初始化数据
            this.formData = {
                id: this.rowData.id || "",
                pageMainTitle: customData.pageMainTitle || this.rowData.pageMainTitle || "",
                pageSubTitle: customData.pageSubTitle || this.rowData.pageSubTitle || "",
                pageChildTitle: customData.pageChildTitle || this.rowData.pageChildTitle || "",
                pageBgImg: customData.pageBgImg || this.rowData.pageBgImg || "",
                pageAnimationImg: customData.pageAnimationImg || this.rowData.pageAnimationImg || "",
                pageBottomImg: customData.pageBottomImg || this.rowData.pageBottomImg || "",
            };
            // 初始化图片列表
            this.pageBgImgList = this.formData.pageBgImg ? [{ url: this.formData.pageBgImg }] : [];
            this.pageAnimationImgList = this.formData.pageAnimationImg ? [{ url: this.formData.pageAnimationImg }] : [];
            this.pageBottomImgList = this.formData.pageBottomImg ? [{ url: this.formData.pageBottomImg }] : [];
        } else if (!val) {
            this.resetForm();
        }
    }

    // 监听图片列表变化，同步到formData
    @Watch("pageBgImgList")
    onPageBgImgChange(val: any[]) {
        this.formData.pageBgImg = val && val.length > 0 ? val[0].url : "";
    }

    @Watch("pageAnimationImgList")
    onPageAnimationImgChange(val: any[]) {
        this.formData.pageAnimationImg = val && val.length > 0 ? val[0].url : "";
    }

    @Watch("pageBottomImgList")
    onPageBottomImgChange(val: any[]) {
        this.formData.pageBottomImg = val && val.length > 0 ? val[0].url : "";
    }

    // 关闭弹窗
    handleClose() {
        this.$emit("update:visible", false);
        this.resetForm();
    }

    // 重置表单
    resetForm() {
        this.formData = cloneDeep(defaultFormData);
        this.pageBgImgList = [];
        this.pageAnimationImgList = [];
        this.pageBottomImgList = [];
        this.$nextTick(() => {
            this.validateForm?.resetFields();
        });
    }

    // 保存
    handleSave() {
        this.validateForm.validate((valid: boolean) => {
            if (valid) {
                this.loading = true;
                // 组装提交数据
                const params = {
                    appComposeId: this.rowData?.id || 0,
                    merchantId: this.rowData?.merchantId || 0,
                    pageMainTitle: this.formData.pageMainTitle,
                    pageSubTitle: this.formData.pageSubTitle,
                    pageChildTitle: this.formData.pageChildTitle,
                    pageBgImg: this.formData.pageBgImg,
                    pageAnimationImg: this.formData.pageAnimationImg,
                    pageBottomImg: this.formData.pageBottomImg,
                };

                appPageSave(params).then(() => {
                    this.$message.success("保存成功");
                    this.$emit("success");
                    this.handleClose();
                }).finally(() => {
                    this.loading = false;
                });
            }
        });
    }
}
